import React from 'react'

import { CreateTeamWizard } from '~/components/create-team/CreateTeamWizard'
import { EmptyTeamsPage } from '~/components/create-team/EmptyTeamsPage'
import { useSetFirstPasskey } from '~/components/create-team/useSetFirstPasskey'
import { useActiveOrg, useRequiredActiveOrg } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'

export const CreateTeam = React.memo(() => {
  const { user: authUser } = useAuthUser()
  const { org } = useActiveOrg()

  // user doesn't have an org yet
  const userHasNoOrgs = authUser?.orgs.length === 0 || org?.isPersonal || !org
  if (userHasNoOrgs) return <EmptyTeamsPage />

  return <CreateTeamInner />
})

const CreateTeamInner = React.memo(() => {
  const org = useRequiredActiveOrg()
  useSetFirstPasskey(org)

  return <CreateTeamWizard />
})

CreateTeam.displayName = 'CreateTeam'
CreateTeamInner.displayName = 'CreateTeamInner'
